import {Injectable, Inject, signal} from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})

export class DatevIntegrationService {
  private _isActivated = signal(false);
  readonly isActivated = this._isActivated.asReadonly();

  private _isUser = signal(false);
  readonly isUser = this._isUser.asReadonly();

  private _isLoading = signal(false);
  readonly isLoading = this._isLoading.asReadonly();

  private _berater = signal<string | null>(null);
  readonly berater = this._berater.asReadonly();

  private _hasMoreClients = signal(false);
  readonly hasMoreClients = this._hasMoreClients.asReadonly();

  constructor(
    @Inject('DATEV_REDIRECT') private DATEV_REDIRECT: string,
    @Inject('DATEV_LINK') private DATEV_LINK: string) {
  }

  getDatevUrl(clientId: string) {
    const check = this.randomString(43);
    const codeChallenge = this.encodeString(check)
    const state = this.randomString(20);
    sessionStorage.setItem('datev_check', check);
    sessionStorage.setItem('datev_state', state);

    const params = new URLSearchParams({
      state,
      scope: 'openid offline_access datev:iam:client:' + clientId + ' datev:accounting:clients accounting:clients:read accounting:documents',
      response_type: 'code id_token',
      redirect_uri: this.DATEV_REDIRECT,
      client_id: '34bcea0929e3361750a5ecdce510d8d6',
      nonce: '358ed7adfa8e7f8382e81ac003eb56fe',
      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      response_mode: 'query'
    });
    return `${this.DATEV_LINK}/authorize?${params.toString()}`;
  }

  private randomString(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    return Array.from({length}, () =>
      chars.charAt(Math.floor(Math.random() * chars.length))
    ).join('');
  }

  private encodeString(string: string): string {
    return CryptoJS.SHA256(string)
      .toString(CryptoJS.enc.Base64)
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
  }

  setUser(value: boolean) {
    this._isUser.set(value);
  }

  setActivated(value: boolean) {
    this._isActivated.set(value);
  }

  setLoading(value: boolean) {
    this._isLoading.set(value);
  }

  setBerater(value: string) {
    this._berater.set(value);
  }

  setHasMoreClients(value: boolean) {
    this._hasMoreClients.set(value);
  }
}
